import { FC, useState } from 'react';
import { MainCard } from '@/components';
import ResetPasswordForm from './components/ResetPasswordForm/ResetPasswordForm';
import styles from './ForgotPassword.module.scss';
import ResetPasswordMessage from './components/ResetPasswordMessage/ResetPasswordMessage';

const ForgotPassword: FC = () => {
  const [isSuccessReset, setIsSuccessReset] = useState(false);
  const [userEmail, setUserEmail] = useState('');

  const onReset = (email: string) => {
    setIsSuccessReset(true);
    setUserEmail(email);
  };

  return (
    <MainCard>
      <div className={styles.forgotPassword}>
        {isSuccessReset ? (
          <ResetPasswordMessage
            userEmail={userEmail}
            restartProcess={() => setIsSuccessReset(false)}
          />
        ) : (
          <ResetPasswordForm onReset={onReset} />
        )}
      </div>
    </MainCard>
  );
};

export default ForgotPassword;
